import { apiBase } from "./base";

const apiVorEditor = {
	client: apiBase.get_client(),
	url: "/editor/vor/",

	getOrCreateCacheJson({ estmId }) {
		return this.client.get(this.url + estmId + "/cache_json/", apiBase.get_headers());
	},

	create({ body }) {
		return this.client.post(this.url + "create/", body, apiBase.get_headers());
	},

	patchVorData({ estmId, body }) {
		return this.client.patch(this.url + estmId + "/", body, apiBase.get_headers());
	},

	convertJsonToDb({ estmId, asCopy }) {
		let asCopyStr = "0";
		if (asCopy) asCopyStr = "1";
		return this.client.get(this.url + estmId + "/convert_to_db/" + asCopyStr + "/", apiBase.get_headers());
	},

	undoVorAction({ estmId, actionId }) {
		return this.client.get(this.url + estmId + "/undo/" + actionId + "/", apiBase.get_headers());
	},

	redoVorAction({ estmId, actionId }) {
		return this.client.get(this.url + estmId + "/redo/" + actionId + "/", apiBase.get_headers());
	},

	createSection({ estmId, body }) {
		return this.client.post(this.url + estmId + "/section/", body, apiBase.get_headers());
	},

	patchSection({ estmId, sectionId, body }) {
		return this.client.patch(this.url + estmId + "/section/" + sectionId + "/", body, apiBase.get_headers());
	},

	deleteSection({ estmId, sectionId }) {
		return this.client.delete(this.url + estmId + "/section/" + sectionId + "/", apiBase.get_headers());
	},

	moveSection({ estmId, sectionId, direction }) {
		return this.client.get(this.url + estmId + "/section/" + sectionId + "/move/" + direction + "/", apiBase.get_headers());
	},

	createWork({ estmId, sectionId, body }) {
		return this.client.post(this.url + estmId + "/section/" + sectionId + "/work/", body, apiBase.get_headers());
	},

	patchWork({ estmId, sectionId, workId, body }) {
		return this.client.patch(this.url + estmId + "/section/" + sectionId + "/work/" + workId + "/", body, apiBase.get_headers());
	},

	deleteWork({ estmId, sectionId, workId }) {
		return this.client.delete(this.url + estmId + "/section/" + sectionId + "/work/" + workId + "/", apiBase.get_headers());
	},

	moveWork({ estmId, sectionId, workId, direction }) {
		return this.client.get(this.url + estmId + "/section/" + sectionId + "/work/" + workId + "/move/" + direction + "/", apiBase.get_headers());
	},

	createRes({ estmId, sectionId, workId, body }) {
		return this.client.post(this.url + estmId + "/section/" + sectionId + "/work/" + workId + "/res/", body, apiBase.get_headers());
	},

	patchRes({ estmId, sectionId, workId, resId, body }) {
		return this.client.patch(
			this.url + estmId + "/section/" + sectionId + "/work/" + workId + "/res/" + resId + "/",
			body,
			apiBase.get_headers()
		);
	},

	deleteRes({ estmId, sectionId, workId, resId }) {
		return this.client.delete(this.url + estmId + "/section/" + sectionId + "/work/" + workId + "/res/" + resId + "/", apiBase.get_headers());
	},

	moveRes({ estmId, sectionId, workId, resId, direction }) {
		return this.client.get(
			this.url + estmId + "/section/" + sectionId + "/work/" + workId + "/res/" + resId + "/move/" + direction + "/",
			apiBase.get_headers()
		);
	},

	getJustFile({ estmId, fileId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + estmId + "/just/" + fileId + "/", headers);
	},

	uploadJustFile({ file, estmId }) {
		const formData = new FormData();
		formData.append("file", file);

		return this.client.post(this.url + estmId + "/just/", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: localStorage.getItem("accessToken"),
				"Auth-Uuid": localStorage.getItem("authUuid"),
			},
		});
	},

	replaceJustFile({ estmId, fileId, file }) {
		const formData = new FormData();
		formData.append("file", file);

		return this.client.post(this.url + estmId + "/just/replace/" + fileId + "/", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: localStorage.getItem("accessToken"),
				"Auth-Uuid": localStorage.getItem("authUuid"),
			},
		});
	},

	connectJustFile({ estmId, body }) {
		return this.client.post(this.url + estmId + "/just/connect/", body, apiBase.get_headers());
	},

	deleteLink({ estmId, sectionId, workId, resId, linkId }) {
		return this.client.delete(
			this.url + estmId + "/section/" + sectionId + "/work/" + workId + "/res/" + resId + "/link/" + linkId + "/",
			apiBase.get_headers()
		);
	},

	patchLink({ estmId, sectionId, workId, resId, linkId, body }) {
		return this.client.patch(
			this.url + estmId + "/section/" + sectionId + "/work/" + workId + "/res/" + resId + "/link/" + linkId + "/",
			body,
			apiBase.get_headers()
		);
	},

	setVisibleSettings({ estmId, body }) {
		return this.client.post(this.url + estmId + "/visible_settings/", body, apiBase.get_headers());
	},

	deleteJustFile({ estmId, fileId }) {
		return this.client.delete(this.url + estmId + "/just/" + fileId + "/", apiBase.get_headers());
	},

	createJustFileHandle({ estmId, body }) {
		return this.client.post(this.url + estmId + "/empty_just/", body, apiBase.get_headers());
	},

	copyItems({ estmId, body }) {
		return this.client.post(this.url + estmId + "/copy_items/", body, apiBase.get_headers());
	},

	renameJustFile({ estmId, fileId, body }) {
		return this.client.patch(this.url + estmId + "/just/rename/" + fileId + "/", body, apiBase.get_headers());
	},

	copyParentWorkLinks({ estmId, sectionId, workId, resId }) {
		return this.client.get(
			this.url + estmId + "/section/" + sectionId + "/work/" + workId + "/res/" + resId + "/copy_parent_work_links/",
			apiBase.get_headers()
		);
	},

	copyParentWorkAttr({ estmId, sectionId, workId, resId, attr }) {
		return this.client.get(
			this.url + estmId + "/section/" + sectionId + "/work/" + workId + "/res/" + resId + "/copy_parent_work_attr/" + attr + "/",
			apiBase.get_headers()
		);
	},

	addJustProjLibFile({ estmId, fileId }) {
		return this.client.get(this.url + estmId + "/add_just_proj_file/" + fileId + "/", apiBase.get_headers());
	},
};

export default apiVorEditor;
